import { useState, useEffect, useContext, useRef } from 'preact/hooks';
import Views from './Views';
import GalleryResults from './GalleryResults';
import Header from './Header';
import ListResults from './ListResults';
import Filters from './Filters';
import { getEncyclopediaResults } from '../../lib/api';
import { FavoritesContext } from '../contexts/FavoritesContext';
import Loading from '../Loading';
import ActiveFilters from './ActiveFilters';
import ContactListResult from './ContactListResults';

export default function EncyclopediaIndex() {
	const { contextLoading } = useContext(FavoritesContext);

	const [view, setView] = useState('gallery');

	const contentRef = useRef();

	const [results, setResults] = useState(null);
	const [loading, setLoading] = useState(false);
	const [totalLoading, setTotalLoading] = useState(true);
	const [pageInfo, setPageInfo] = useState({});

	const [filters, setFilters] = useState({
		ordering: 'DATE-DESC', // Has to be ORDERBY-ORDER (dash)
		industryTerms: [],
		specieTerms: [],
		countyTerms: [],
		types: [],
		favorites: null
	});
	const [freeTextSearch, setFreeTextSearch] = useState('');

	useEffect(() => {
		getData(filters, freeTextSearch);
	}, [filters, freeTextSearch]);

	async function getData(
		filters,
		freeTextSearch,
		after = null,
		before = null
	) {
		setLoading(true);
		const [data, pageInfo] = await getEncyclopediaResults(
			filters,
			freeTextSearch,
			after,
			before
		);
		setPageInfo(pageInfo);
		setResults(data);
		setLoading(false);
	}

	function scrollUp() {
		const { offsetTop } = contentRef.current;
		window.scrollTo({ top: offsetTop, behavior: 'smooth' });
	}

	function nextPage() {
		scrollUp();
		getData(filters, freeTextSearch, pageInfo.endCursor);
	}

	function prevPage() {
		scrollUp();
		getData(filters, freeTextSearch, null, pageInfo.startCursor);
	}

	useEffect(() => {
		if (contextLoading === false && loading === false) {
			setTotalLoading(false);
		}
	}, [contextLoading, loading]);

	return (
		<div>
			<Header
				freeTextSearch={freeTextSearch}
				setFreeTextSearch={setFreeTextSearch}
			/>
			<div ref={contentRef} class="container pt-4 lg:py-14 flex">
				{totalLoading ? (
					<Loading color="text-light-turquoise" />
				) : (
					<>
						<Filters filters={filters} setFilters={setFilters} />
						<div class="w-full lg:w-9/12">
							<Views
								view={view}
								setView={setView}
								filters={filters}
								setFilters={setFilters}
							/>
							<ActiveFilters
								filters={filters}
								setFilters={setFilters}
							/>
							<div class="my-10 md:my-14 relative">
								{results?.length >= 1 ? (
									<>
										{view === 'gallery' ? (
											<GalleryResults results={results} />
										) : view === 'list' ? (
											<ListResults results={results} />
										) : (
											<ContactListResult
												results={results}
											/>
										)}
										<div className="mt-6 flex justify-center">
											{pageInfo.hasPreviousPage && (
												<button
													className="h-11 text-base rounded-lg mr-4 px-4 focus:outline-none bg-dark text-white"
													onClick={() => prevPage()}
												>
													Forrige side
												</button>
											)}
											{pageInfo.hasNextPage && (
												<button
													className="h-11 text-base rounded-lg px-4 focus:outline-none bg-dark text-white"
													onClick={() => nextPage()}
												>
													Neste side
												</button>
											)}
										</div>
									</>
								) : (
									<p class="bg-light-gray bg-opacity-40 rounded-md p-10 text-center">
										Ingen resultater matcher dine filtre.
									</p>
								)}

								{loading && (
									<div class="absolute top-0 left-0 w-full h-full bg-white bg-opacity-50"></div>
								)}
							</div>
						</div>
					</>
				)}
			</div>
		</div>
	);
}
